module.exports = __webpack_public_path__ + "assets/img/about.4d4b120d.png";